import VueCompositionAPI from "@vue/composition-api"
import Vue from "vue"

Vue.use(VueCompositionAPI)
